import React, { type ReactNode, useEffect } from "react";
import { useAuth } from "react-oidc-context";

import FullScreenSpinner from "../components/LoadingSpinner/FullScreenSpinner";
import { useStore } from "../zustand-store";

const AuthWrapper: React.FC<{ children: ReactNode }> = ({ children }) => {
  const auth = useAuth();
  const setUser = useStore((s) => s.setUser);

  useEffect(() => {
    if (!auth.isAuthenticated && !auth.isLoading) {
      const idp = import.meta.env.VITE_IDP;
      auth.signinRedirect(!!idp ? { extraQueryParams: { identity_provider: idp } } : {});
    }
  }, [auth]);

  if (auth.isLoading) {
    return <FullScreenSpinner type="ellipsis" />;
  } else if (auth.isAuthenticated) {
    console.log("profile", auth.user?.profile);
    const profile = auth.user?.profile as any as {
      email: string;
      name: string;
      family_name: string;
      "custom:userId": string;
    };
    const customerId = profile["custom:userId"];
    let username = profile.name;
    if (profile.name.includes(",")) {
      username = profile.name.split(",").reverse().join(" ");
    } else if (!profile.name.includes(profile.family_name)) {
      username = `${profile.name} ${profile.family_name}`;
    }
    const email = profile.email;
    setUser({ username, email, customerId });
  }

  return <>{children}</>;
};

export default AuthWrapper;
